import _ from 'lodash'

export const getters = {

    isAuthenticated(state, getters) {
        return false;
    },

    userAgent(state) {
        return state.userAgent
    },

}
